module.exports = __webpack_public_path__ + "d54e3f9ed25562af55fe19390fc05268.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-22.png
// module id = 2008
// module chunks = 0